function epicAccountLoyalty () {
  Shopify.theme.jsEpicAccountLoyalty = {
    init: function init() {
      this.customizeSpendAndSaveSlider();
    },
    initSpendAndSaveSlider: function initSpendAndSaveSlider(sliderElement) {
      let autoplayInterval = sliderElement.getAttribute('data-autoplay-interval');
      let options = {
        cellAlign: 'left',
        adaptiveHeight: false,
        prevNextButtons: false,
        pageDots: true,
        contain: true,
        adaptiveHeight: false,
        autoPlay: autoplayInterval ? autoplayInterval * 1000 : false
      };
      let flkty = null;

      if (window.innerWidth <= 768) {
        flkty = new window.Flickity(sliderElement, options);
      }

      return flkty;
    },
    handleSpendAndSaveSliderResize: function handleSpendAndSaveSliderResize(sliders, sliderInstances, initSpendAndSaveSlider) {
      sliders.forEach(sliderElement => {
        let flkty = sliderInstances.get(sliderElement);

        if (window.innerWidth <= 768) {
          if (!flkty) {
            flkty = initSpendAndSaveSlider(sliderElement);
            sliderInstances.set(sliderElement, flkty);
          }
        } else if (flkty) {
          flkty.destroy();
          sliderInstances.delete(sliderElement);
        }
      });
    },
    customizeSpendAndSaveSlider: function customizeSpendAndSaveSlider() {
      let sliders = [...document.querySelectorAll('.spend-and-save-slider')];
      let sliderInstances = new Map();
      let self = this;

      let resizeHandler = function () {
        self.handleSpendAndSaveSliderResize(sliders, sliderInstances, self.initSpendAndSaveSlider.bind(self));
      };

      resizeHandler();
      window.addEventListener('resize', resizeHandler);
    }
  };
  Shopify.theme.jsEpicAccountLoyalty.init();
}

export { epicAccountLoyalty as default };
